"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuPanelContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _componentUtils = require("../../common/componentUtils");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function MenuPanelContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const cid = data.cid,
    color = data.color,
    gradientColor = data.gradientColor,
    paddingTopNum = data.paddingTopNum,
    paddingBottomNum = data.paddingBottomNum;
  const style = (0, _componentUtils.doComponentsStyleEvent)({
    color,
    gradientColor,
    paddingTopNum,
    paddingBottomNum
  }); // 处理组件背景色
  const renderChild = child => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains: domainInfos
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "menu-panel-container",
    id: `cid-${cid}`,
    style: style
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("div", {
    style: commonStyle,
    key: index
  }, renderChild(child))));
}